
export function onSignup(state: any, action: any) {
  localStorage.setItem('__login', 'true'); // TODO: this needs to be moved to correct place
  return state;
}